import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useBehaviourEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { route, router } = useRouter()
  const { getItem, updateItem } = useLambda()
  const { addAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const behaviour = ref({})
  const isSubmitting = ref(false)
  const originalData = ref(null)
  const query = {
    _id: oid(route.value.params.id),
    client_id: oid(userData.client.$oid),
    deleted: { $ne: true },
  }
  const collection = 'behaviour'

  const show = async () => {
    isSubmitting.value = true

    try {
      const item = await getItem({ collection, query })

      if (!item) {
        showErrorMessage(i18n.t('message.you_are_not_authorized'))
        router.push({ name: 'organization-behaviour-list' })
        return
      }

      // Inicializar history si no existe (documentos legacy)
      if (!item.history) {
        item.history = []
      }

      behaviour.value = item
      originalData.value = JSON.parse(JSON.stringify(item))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.behaviour_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  const update = async (data) => {
    if (!hasPermission('task-behaviours', 'edit')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const payload = {
        name: data.name.value,
        type: data.type.value,
        requiresEvidence: data.requiresEvidence.value,
      }

      if (payload.type === 'bool') payload.expectedAnswer = data.expectedAnswer.value

      const action = { $set: payload }

      await updateItem({ collection, query, action })

      await addAuditEntry({
        collection,
        documentId: oid(route.value.params.id),
        originalData: originalData.value,
        updatedData: payload,
      })

      showSuccessMessage(i18n.t('message.behaviour_updated'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.behaviour_update_error'))
    } finally {
      router.push({ name: 'organization-behaviour-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    behaviour,
    isSubmitting,
  }
}
